import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
  CircularProgress,
  Alert,
  Autocomplete,
  TextField,
} from "@mui/material";
import * as React from "react";
import { fetchPayments } from "../../utils/Utils";
import {
  CourseType,
  PaymentsType,
  RepresentativeType,
  StudentFormType,
} from "../../types/entitiesModel";

interface PaymentStudentdataPublicType {
  setSelectionPaymentMethod: (value: PaymentsType | null) => void;
  selectionPaymentMethod: PaymentsType | null;
  studentData: StudentFormType | null;
  representativeData: RepresentativeType | null;
  courseData: CourseType | null;
  reference?: string;
  setReference?: (value: string) => void;
  isMonthlyPay?: boolean | null;
}

const PaymentStudentdataPrivate: React.FC<PaymentStudentdataPublicType> = (
  props: PaymentStudentdataPublicType
) => {
  const [payments, setPayments] = React.useState<PaymentsType[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    fetchPayments(setLoading, setPayments, setError);
  }, []);

  return (
    <>
      {!loading ? (
        <Grid item lg={12} md={12} xs={12}>
          <Card variant="outlined" sx={{ p: 0 }}>
            {error ? (
              <Alert sx={{ mx: "auto", my: 2, width: "95%" }} severity="error">
                {error}
              </Alert>
            ) : (
              <>
                <Box
                  sx={{ padding: "15px 30px" }}
                  display="flex"
                  alignItems="center"
                >
                  <Box flexGrow={1}>
                    <Typography sx={{ fontSize: "18px", fontWeight: "500" }}>
                      Datos de la inscripción
                    </Typography>
                  </Box>
                </Box>
                <Divider />

                {/* Contenedor de columnas superiores */}
                <CardContent sx={{ padding: "30px" }}>
                  <Grid container spacing={3}>
                    {/* Columna 1: Datos del Estudiante */}
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="h5"
                        sx={{ mb: 1, fontWeight: "bold" }}
                        gutterBottom
                      >
                        Datos del Estudiante
                      </Typography>
                      <Typography variant="body1">
                        <strong>Nombre:</strong> {props.studentData?.name}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Documento:</strong>{" "}
                        {props.studentData?.document}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Email:</strong> {props.studentData?.email}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Teléfono:</strong> {props.studentData?.phone}
                      </Typography>
                    </Grid>

                    {/* Columna 2: Datos del Representante */}
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="h5"
                        sx={{ mb: 1, fontWeight: "bold" }}
                        gutterBottom
                      >
                        Datos del Representante
                      </Typography>
                      <Typography variant="body1">
                        <strong>Nombre:</strong>{" "}
                        {props.representativeData?.name}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Documento:</strong>{" "}
                        {props.representativeData?.document}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Correo:</strong>{" "}
                        {props.representativeData?.email}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Relación:</strong>{" "}
                        {props.representativeData?.relationship}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Teléfono:</strong>{" "}
                        {props.representativeData?.phone}
                      </Typography>
                    </Grid>

                    {/* Columna 3: Información del Curso */}
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="h5"
                        sx={{ mb: 1, fontWeight: "bold" }}
                        gutterBottom
                      >
                        Información del Curso
                      </Typography>
                      <Typography variant="body1">
                        <strong>Nombre del Curso:</strong>{" "}
                        {props.courseData?.group_name}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Precio mensualidad:</strong>{" "}
                        {props.courseData?.monthly_fee}
                      </Typography>
                      {props.isMonthlyPay !== null &&
                      props.isMonthlyPay === true ? (
                        <></>
                      ) : (
                        <Typography variant="body1">
                          <strong>Precio Inscripción:</strong>{" "}
                          {props.courseData?.enrollment_fee}
                        </Typography>
                      )}
                      <Typography variant="body1">
                        <strong>Precio total:</strong>{" "}
                        {props.isMonthlyPay !== null && props.isMonthlyPay ? (
                          props.courseData?.enrollment_fee &&
                          props.courseData.monthly_fee ? (
                            Number(props.courseData?.monthly_fee)
                          ) : (
                            <></>
                          )
                        ) : (
                          props.courseData?.enrollment_fee &&
                          props.courseData.monthly_fee &&
                          Number(props.courseData?.enrollment_fee) +
                            Number(props.courseData?.monthly_fee)
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>

                <Divider sx={{ mt: 3 }} />

                {/* Sección inferior centrada para el Método de Pago con mayor ancho */}
                <CardContent sx={{ padding: "30px", textAlign: "center" }}>
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ mb: 2, fontWeight: "bold" }}
                  >
                    Selección del Método de Pago
                  </Typography>
                  <Autocomplete
                    options={payments}
                    getOptionLabel={(option: PaymentsType) =>
                      option.account_name
                    }
                    onChange={(event, newValue) => {
                      props.setSelectionPaymentMethod(newValue || null);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Método de pago"
                        variant="outlined"
                        fullWidth
                        placeholder="Selecciona un Método de pago"
                      />
                    )}
                    value={props.selectionPaymentMethod || null}
                    sx={{ mb: 2, width: "75%", mx: "auto" }} // Cambiado a 75%
                  />

                  {props.selectionPaymentMethod && (
                    <Box sx={{ textAlign: "left", mx: "auto", width: "75%" }}>
                      <TextField
                        id="reference"
                        label="Introducir referencia"
                        type="text"
                        variant="outlined"
                        placeholder="Introducir referencia"
                        fullWidth
                        name="reference"
                        onChange={(e) => {
                          if (props.setReference) {
                            props.setReference(e.target.value);
                          }
                        }}
                        sx={{ mb: 2 }}
                      />
                      <Typography variant="body1">
                        <strong>Banco/Cuenta:</strong>{" "}
                        {props.selectionPaymentMethod?.account_name}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Documento/cédula:</strong>{" "}
                        {props.selectionPaymentMethod?.document}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Número de cuenta/Correo:</strong>{" "}
                        {props.selectionPaymentMethod?.account_number}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Tipo:</strong>{" "}
                        {props.selectionPaymentMethod?.type}
                      </Typography>
                    </Box>
                  )}
                </CardContent>
              </>
            )}
          </Card>
        </Grid>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
};

export default PaymentStudentdataPrivate;
